import { useState, useRef, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { FiRefreshCw, FiPhone } from "react-icons/fi";
import { fetchLiveCallStatus } from "../../../pages/actions/actions";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getTicketById } from "../../../http";
import { ticketDataSuccess } from "../../../redux/ticketSlice/ticketSlice";
import style from "./liveCallsDropdown.module.scss";

export const LiveCallsDropdown = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleTicketClick = async (ticketId: string) => {
    if (!ticketId) return;
    try {
      const response = await getTicketById(ticketId);
      dispatch(ticketDataSuccess(response?.data));
      navigate(`/handleEmergency/${ticketId}`);
    } catch (e) {
      navigate(`/handleEmergency/${ticketId}`);
    }
    setOpen(false);
  };

  const { data: liveCalls = [], isFetching, refetch } = useQuery({
    queryKey: ["liveCallStatus"],
    queryFn: () => fetchLiveCallStatus(),
    enabled: open,
    refetchInterval: open ? 30000 : false,
    staleTime: 0,
  });

  const activeCalls = liveCalls.length;

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={style.wrapper} ref={ref}>
      <div className={style.trigger} onClick={() => setOpen((p) => !p)}>
        <FiPhone size={16} />
        <span className={style.label}>Live Calls</span>
        {activeCalls > 0 && (
          <span className={style.badge}>{activeCalls}</span>
        )}
      </div>

      {open && (
        <div className={style.dropdown}>
          <div className={style.header}>
            <span>Live Calls</span>
            <button
              className={`${style.refresh} ${isFetching ? style.spinning : ""}`}
              onClick={(e) => { e.stopPropagation(); refetch(); }}
              title="Refresh"
            >
              <FiRefreshCw size={14} />
            </button>
          </div>

          <div className={style.list}>
            {liveCalls.length === 0 ? (
              <p className={style.empty}>No live calls</p>
            ) : (
              liveCalls.map((call) => (
                <div key={call.ticketId} className={style.item} onClick={(e) => { e.stopPropagation(); handleTicketClick(call.ticketId); }}>
                  <span className={style.dot} />
                  <span className={style.ticketId}>Ticket - {call.ticketId}</span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};
